module.exports = __webpack_public_path__ + "img/mycolour.96fba7d2.png";